import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export function getLicenseListGlobal(
    subscription: string,
    tenant: number,
    token: string,

){

  return axios.get( `${API_URL}/v1/CTX-R/${subscription}/list?tenantId=${tenant}`,
    {
      headers:{Authorization:  `Bearer ${token}`} 
    }
  )
}

export function getLicenseIdGlobal(
    subscription: string,
    tenant: number,
    id: number,
    token: string,

){

  return axios.get( `${API_URL}/v1/CTX-R/${subscription}/${id}?tenantId=${tenant}`,
    {
      headers:{Authorization:  `Bearer ${token}`} 
    }
  )
}

export function getLicenseListByLicense(
  subscription: number | string,
  tenant: number,
  licenseId: number | string,
  token: string
) {
  return axios.get(
    `${API_URL}/v1/ctxr/${subscription}/listbylicence/${licenseId}?tenantId=${tenant}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}


export function updateLicense(
  licenseId:number,
  subscription: number,
  tenant: number,
  token: string,
  description: string
){
  return axios.put(
    `${API_URL}/v1/CTX-R/${subscription}/${licenseId}?tenantId=${tenant}` ,{description},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json", 
      },
    }
  );
}
